import React, { useEffect } from 'react';
import { Container } from '@material-ui/core';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import PostDetails from './components/PostDetails/PostDetails';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Auth from './components/Auth/Auth';

const App = () => {
  const user = JSON.parse(localStorage.getItem('profile'));

  // console.log("USER ", user);

  return (
    <BrowserRouter>
      <Container maxWidth="xl">
        <Navbar />
        <Switch>
          <Route path="/" exact component={() => <Redirect to="/posts" />} />
          <Route path="/posts" exact component={Home} />
          <Route path="/posts/search" exact component={Home} />
          <Route path="/posts/:id" exact component={PostDetails} />
          <Route path='/https://www.instagram.com/i_am_akash2701/' exact component={() => window.location.href = 'https://www.instagram.com/i_am_akash2701/'} />
          <Route path='/https://www.linkedin.com/in/akash-kumar-6337b01a5/' exact component={() => window.location.href = 'https://www.linkedin.com/in/akash-kumar-6337b01a5/'} />
          <Route path='/https://www.facebook.com/profile.php?id=100006448988810' exact component={() => window.location.href = 'https://www.facebook.com'} />
          <Route path='/https://github.com/AkashKumar2701' exact component={() => window.location.href = 'https://github.com/AkashKumar2701'} />
          <Route path="/auth" exact component={() => (!user?.result ? <Auth /> : <Redirect to="/posts" />)} />
        </Switch>
      </Container>
    </BrowserRouter>
  );
};

export default App;
